module.exports = __webpack_public_path__ + "static/media/05-img-04@3x.63531c79.webp";